import LOCATIONPREFERENCE from 'data/mantechcar25/location-preference.json';
import { useI18n } from 'hooks/useI18n';
import {
  ChartWrapper,
  StyledCaption,
  StyledItem,
  StyledItems,
  StyledLegend,
  StyledLegendItem,
  StyledPrefersValue,
  StyledValueContainer
} from './LocationPreference.styled';
import { useRouter } from 'next/router';
import { Cell, Legend, Pie, PieChart, Tooltip } from 'recharts';
import { StyledRecharts } from '../shared/recharts/Recharts.styled';

const LocationPreference: React.FC = () => {
  const { t } = useI18n('developer-career-report-2025');
  const { locale } = useRouter();

  const maxValue = Math.max(
    ...LOCATIONPREFERENCE.map((obj) => {
      if (obj.prefersValue >= obj.offeredValue) {
        return obj.prefersValue;
      } else {
        return obj.offeredValue;
      }
    })
  );

  const pieData = LOCATIONPREFERENCE.map((obj) => ({
    name: obj.label,
    value: obj.prefersValue,
    fill: obj.fill
  }));

  return (
    <StyledItems>
      <ChartWrapper>
        <StyledRecharts className="location preference">
          <PieChart height={400} width={600}>
            <Legend
              layout="vertical"
              align="right"
              verticalAlign="middle"
              iconType="square"
              width={200}
              wrapperStyle={{
                paddingLeft: '20px'
              }}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=": "
              formatter={(value: number) => `${value.toFixed(1)}%`}
              wrapperClassName="tooltip-y"
            />
            <Pie data={pieData} dataKey="value" cx="50%" cy="50%">
              <Cell name={t('mantechcar25.benefits.location.remote')} />
              <Cell name={t('mantechcar25.benefits.location.hybrid')} />
              <Cell name={t('mantechcar25.benefits.location.onsite')} />
            </Pie>
          </PieChart>
        </StyledRecharts>
      </ChartWrapper>
    </StyledItems>
  );
  return (
    <>
      <StyledItems>
        {LOCATIONPREFERENCE.map((item) => (
          <StyledItem key={item.type}>
            <StyledCaption>{t(item.label)}</StyledCaption>
            <StyledValueContainer>
              <StyledPrefersValue
                style={
                  {
                    '--coeficient': item.prefersValue / maxValue
                  } as React.CSSProperties
                }
              />
              {/* <StyledOfferedValue
                className={
                  item.offeredValue > item.prefersValue ? 'reverse' : ''
                }
                style={
                  {
                    '--coeficient': item.offeredValue / maxValue
                  } as React.CSSProperties
                }
              /> */}
            </StyledValueContainer>
            <StyledLegend>
              <StyledLegendItem>
                {t('mantechcar25.benefits.location.preference')}:{' '}
                {item.prefersValue.toFixed(1)}%
              </StyledLegendItem>
              {/* <StyledLegendItem>
                {t('mantechcar25.benefits.location.offer')}:{' '}
                {item.offeredValue.toFixed(1)}%
              </StyledLegendItem> */}
            </StyledLegend>
          </StyledItem>
        ))}
      </StyledItems>
    </>
  );
};

export default LocationPreference;
